require('./bootstrap');
require('./_global');
require('./components/vue-declarator');
require('./polygons_map');



// WEBPACK FOOTER //
// ./resources/js/admin-panel/main.js